import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=ab42d1c2&scoped=true"
import script from "./Header.ts?vue&type=script&lang=ts&external"
export * from "./Header.ts?vue&type=script&lang=ts&external"
import style0 from "./Header.vue?vue&type=style&index=0&id=ab42d1c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab42d1c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab42d1c2')) {
      api.createRecord('ab42d1c2', component.options)
    } else {
      api.reload('ab42d1c2', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=ab42d1c2&scoped=true", function () {
      api.rerender('ab42d1c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Cups/components/Header/Header.vue"
export default component.exports